import { CREATE_VORLAGE_STATION } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateVorlageStation/mutation';
import {
  Mitarbeiter_CreateVorlageStationMutation,
  Mitarbeiter_CreateVorlageStationMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateVorlageStation() {
  const [execute, result] = useMutation<
    Mitarbeiter_CreateVorlageStationMutation,
    Mitarbeiter_CreateVorlageStationMutationVariables
  >(CREATE_VORLAGE_STATION, {
    refetchQueries: [
      'mitarbeiter_rotationsplanVorlagen',
      'mitarbeiter_rotationsplanVorlageById',
    ],
    awaitRefetchQueries: true,
  });

  const createVorlageStation = useCallback(
    (variables: Mitarbeiter_CreateVorlageStationMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createVorlageStation, result] as const;
}
